import BaseView from '@/store/modules/components/BaseView'

export default class OrgsView extends BaseView {
    constructor() {
        super('orgs')
    }
}
